export default __webpack_public_path__ + "static/media/_ic_home.553a4c84.svg";